/* Styled Components are hard code they will get from server once integrated */
import styled from "styled-components";
import { starzRevamp as theme } from "starz-visual-themes";
import { i18n } from "../../services/i18nService";
import { Button, Heading } from "../../services/visualLibraryService";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const PlayerDiv = styled.div`
  width: 100%;
  height: 100%;
`;

export const LowerPlayerControls = styled.div`
  width: 100%;
  height: 3.3em;
  position: absolute;
  margin-top: 51em;
  z-index: 9999;
`;

export const PlayPauseToggle = styled.a`
  margin-left: 5em;
`;

export const ToggleBtn = styled.svg.attrs({
  viewBox: theme.components.icon.viewBox
})`
  width: 2.5em;
  height: 2.5em;
  margin-top: 0.7em;
`;

export const FillBtnPlay = styled.path.attrs(props => ({
  d: theme.components.icon.list["play"].path
}))`
  fill: ${theme.color.greyTaupe};
  fill-opacity: 1;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const FillBtnPause = styled.path.attrs(props => ({
  d: theme.components.icon.list["pause"].path
}))`
  fill: ${theme.color.greyTaupe};
  fill-opacity: 1;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const CurrentPlay = styled.div`
  position: absolute;
  display: inline-table;
  margin-top: 1em;
  margin-left: ${props => (props.currentState === 5 ? "0em" : "1em")};
`;

export const TotalPlayTime = styled.div`
  position: absolute;
  display: inline-table;
  margin-top: 1em;
  margin-left: 79.8em;
`;

export const CurrentAndTotalPlaySpan = styled.span`
  font-weight: bold;
  font-family: sans-serif;
  font-size: ${theme.font.size.default};
  text-align: center;
  display: inline-block;
  color: ${theme.color.greyLight};
  margin: 0 ${theme.spacing.xsmall};
  flex-shrink: 0;
`;

export const ProgressBarContainer = styled.div`
  position: absolute;
  bottom: 14em;
  left: 14.55em;
  top: 1.7em;
  margin: 0 ${theme.spacing.xsmall};
  width: 72em;
  height: 0.42rem;
  border-style: none;
  border-radius: 2em;
`;

export const ProgressBar = styled.progress`
  height: 0.42rem;
  position: absolute;
  // background-color: rgba(${theme.color.greyRGB}, 0.65);
  display: inline-block;
  top: 0;
  width: 72em;
  border-style: none;
  border-radius: 2em;
  z-index: ${theme.zIndex.base};
  ::-webkit-progress-value {
    background: ${theme.color.primary};
   background: ${theme.color.white};
    border-style: none;
    border-radius: 2em;
  }
  ::-webkit-progress-bar {
    border-style: none;
    border-radius: 2em;
     background-color: rgba(${theme.color.greyRGB}, 0.4);
  }
`;

export const AdBreaksListStyled = styled.ul`
  position: absolute;
  left: 0;
  width: 100%;
  height: 0.42rem;
  z-index: 999;
`;
export const AdBreaksStyled = styled.li`
  position: absolute;
  top: 0;
  left: ${props => props.margin}%;
  // width: ${props => props.width}%;
  width: 0.4em;
  height: 100%;
  ${props => (props.margin === 0 ? "border-radius: 2em 0 0 2em" : props.margin > 99 && "border-radius: 0 2em 2em 0")};
  background: ${props => (props.isAdExist ? theme.color.yellow : "#00cea0")};
`;

export const ProgressBarContainerAd = styled.div`
  position: absolute;
  left: 4.688vw;
  top: -1.5em;
  margin: 0 ${theme.spacing.xsmall};
  width: 90.625vw;
  height: 0.42rem;
  border-style: none;
  border-radius: 2em;
`;

export const ProgressBarAd = styled.progress`
  height: 0.42rem;
  position: abnsolute;
  // background-color: rgba(${theme.color.greyRGB}, 0.65);
  display: inline-block;
  top: 0;
  width: 90.625vw;
  border-style: none;
  border-radius: 2em;
  z-index: ${theme.zIndex.base};
  ::-webkit-progress-value {
    background: ${theme.color.yellow};
    border-style: none;
    border-radius: 2em;
  }
  ::-webkit-progress-bar {
    border-style: none;
    border-radius: 2em;
    background-color: rgba(${theme.color.greyRGB}, 0.65);
  }
`;

export const LowerPlayerControlsAds = styled.div`
  width: 100%;
  height: 3.3em;
  position: absolute;
  margin-top: 48em;
  z-index: 9999;

  .adsButtons {
    ${props =>
      props.theme.locale.dir === "rtl" &&
      `
      button {
        direction: rtl;
      }
    `}
  }
`;

export const NextPlayBackShade = styled.div`
  width: 100%;
  height: 100%;
  background-color: #000 !important;
`;

export const ControlsSettingsStyled = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  padding: ${theme.spacing.medium} ${theme.baseLayoutPaddingBs}%;
  z-index: ${theme.zIndex.base};
`;

export const LabelDiv = styled.div`
  position: absolute;
  width: 25em;
  height: 3em;
  top: 0;
  padding: 5.5rem 5%;
`;

export const LabelStyled = styled.span`
  display: inline-block;
  margin-left: ${theme.spacing.default};
  font-size: 1.6em;
  color: ${theme.color.white};
  display: block;
  position: absolute;
  margin-top: 0.5em;
  opacity: 1;
  z-index: 11;
`;

export const ButtonsAdsStyled = styled.div`
  margin-top: -13vh;
  margin-left: 5.4vw;
`;

export const AdInfoStyled = styled.div`
  position: absolute;
  left: 5.4vw;
  bottom: -1.2rem;
  display: flex;
  p:first-child {
    font-weight: 900 !important;
  }
`;
export const AdTextStyled = styled.div`
  display: flex;
  font-size: 2rem;
  color: #ffffff;
  line-height: 3rem;
  margin-left: 1rem;

  > p {
    margin: 0 0.5rem;
  }
`;

export const AdDotStyled = styled.span`
  font-size: ${props => (props.theme.locale.dir === "rtl" ? "3rem" : "5rem")};
  margin: ${props => (props.theme.locale.dir === "rtl" ? "0 0.7rem" : "0 0.4rem")};
`;

export const ControlSettingsBtn = styled.svg.attrs({
  viewBox: theme.components.icon.viewBox
})`
  width: 2.5em;
  height: 2.5em;
  margin: 0 ${theme.spacing.xsmall} 0 ${theme.spacing.small};
`;

export const FillBtnBack = styled.path.attrs(props => ({
  d: theme.components.icon.list[i18n.getDirection() === "ltr" ? "arrowLeft" : "arrowRight"].path
}))`
  fill: ${theme.color.greyTaupe};
  fill-opacity: 1;
  z-index: 12;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const FillBtnLanguage = styled.path.attrs(props => ({
  d: theme.components.icon.list["language"].path
}))`
  fill: ${theme.color.greyTaupe};
  fill-opacity: 1;
  z-index: 12;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const FillBtnStart = styled.path.attrs(props => ({
  d: theme.components.icon.list["playBeginning"].path
}))`
  fill: ${theme.color.greyTaupe};
  fill-opacity: 1;
  z-index: 12;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const FillBtnEpisode = styled.path.attrs(props => ({
  d: theme.components.icon.list["episodes"].path
}))`
  fill: ${theme.color.greyTaupe};
  fill-opacity: 1;
  z-index: 12;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const SkipAdButton = styled(Button)`
  margin-right: 2rem;
  ${props =>
    props.disabled &&
    `
    opacity: 0.6;
  `}
  > svg {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
  }
`;
export const ButtonRemoveAdStyled = styled.div`
  width: 10rem;
  height: 3rem;
  position: absolute;
  background: rgba(66, 66, 66, 1);
  bottom: 4rem;
  left: ${props => props.theme.baseLayoutPaddingBs + "%"};
  background-color: ${props => props.selectFocusBtnAdRemoved && "#fff"};
  ${props => (props.selectFocusBtnAdRemoved ? "color : #000 " : "color : #fff ")};
  font-size: 1.2rem;
  font-weight: 700;
  display: inline-flex;
  border-radius: 0.5rem;
  align-items: center;
  justify-content: center;
`;
